import axios from 'axios';
import { useRouter } from 'next/router';
import React, { memo, useState, useEffect } from 'react';
import Link from 'next/link';
import { get_dynamic_styles } from '../../constant/DynamicStyles';

const Counter = ({ data, styles, rules }) => {
  const [title, setTitle] = useState(data?.title);
  const [number, setNumber] = useState('');

  useEffect(() => {
    if (data?.data_source === 'seller_earning') {
      axios.get('/api/a/earning').then((res) => {
        if (data?.earning_data_type === 'total_sales') {
          setNumber(res.data?.total_sales?.formatted);
        } else if (data?.earning_data_type === 'pending_balance') {
          setNumber(res.data?.pending_balance?.formatted);
        } else if (data?.earning_data_type === 'total_payouts') {
          setNumber(res.data?.total_payouts?.formatted);
        }
      });
    }
  }, []);

  return (
    <div
      className="w-full    flex  items-center justify-center"
      style={{
        ...get_dynamic_styles(styles?.main_styles),
        display: styles?.main_styles?.display,
      }}
    >
      <h2 style={get_dynamic_styles(styles?.title_style)}>{title}</h2>
      <p style={get_dynamic_styles(styles?.number_style)}>{number}</p>
    </div>
  );
};

export default memo(Counter);
